var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: ["main_head", _vm.showMax ? "max-height" : ""] },
    [
      _c("corporateEquity", { ref: "corporateEquity" }),
      _c(
        "div",
        { staticClass: "careful-search" },
        _vm._l(_vm.carefulList, function (item, index) {
          return _c(
            "span",
            {
              key: index,
              class: _vm.activeTab == index ? "active-class" : "",
              on: {
                click: function ($event) {
                  return _vm.clickTab(item, index)
                },
              },
            },
            [_vm._v(_vm._s(item.searchValue))]
          )
        }),
        0
      ),
      _c(
        "div",
        { staticClass: "search" },
        [
          _c(
            "el-autocomplete",
            {
              attrs: {
                "popper-class": "recommend-head-autocomplete",
                maxlength: 50,
                placeholder: _vm.placeholder,
                size: "small",
                "fetch-suggestions": _vm.querySearch,
              },
              on: { select: _vm.submit1 },
              nativeOn: {
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.submit.apply(null, arguments)
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c("div", {
                        staticClass: "name",
                        domProps: { innerHTML: _vm._s(item.name) },
                      }),
                    ]
                  },
                },
              ]),
              model: {
                value: _vm.word,
                callback: function ($$v) {
                  _vm.word = $$v
                },
                expression: "word",
              },
            },
            [
              _c(
                "a",
                {
                  staticClass: "searchBtn",
                  attrs: { slot: "suffix" },
                  on: { click: _vm.submit },
                  slot: "suffix",
                },
                [_c("div", { staticClass: "icon" })]
              ),
            ]
          ),
        ],
        1
      ),
      _vm.showMax
        ? _c(
            "div",
            { staticClass: "hot-search" },
            _vm._l(_vm.enterList, function (item, i) {
              return _c(
                "a",
                {
                  key: i,
                  on: {
                    click: function ($event) {
                      return _vm.jumpUrl(item)
                    },
                  },
                },
                [
                  _c("p", [
                    _c("img", {
                      staticClass: "img no-img",
                      attrs: { src: item.img },
                    }),
                    _c("img", {
                      staticClass: "img img-active",
                      attrs: { src: item.imgActive },
                    }),
                    _vm._v(" " + _vm._s(item.name) + " "),
                  ]),
                ]
              )
            }),
            0
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }